/**
 * pre-fill the ticket form with film & show information
 */

var fillTicketForm = function() {
    var field = document.querySelector('#form_element_2005');
    if (field) {
        var show = findGetParameter('show');
        if (show) {
            show = decodeURIComponent(show.replace(/\+/g, '%20'));
            field.focus();
            field.value = show;
            field.blur(); // i4 validator anstossen
        }
    }
};

window.addEventListener('DOMContentLoaded', fillTicketForm());

$(function() {
    fillTicketForm();
});

/**
 * get a GET param from URL
 */

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    var items = location.search.substr(1).split("&");
    for (var index = 0; index < items.length; index++) {
        tmp = items[index].split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    }
    return result;
}

/**
 *  add .focus class to form element's labels
 */
var inputs = document.querySelectorAll('input, select, textarea');
for (var i = 0; i < inputs.length; i++) {
    var input = inputs[i];
    if (input.id) {
        var label = document.querySelector('label[for=\'' + input.id + '\']');
        input.onfocus = function (e) { // jshint ignore:line
            label.classList.add('focus');
        };
        input.onblur = function (e) { // jshint ignore:line
            label.classList.remove('focus');
        };
    }
}



